//react
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

//components
import Translation from '../../components/translation/translation';

//data
import dataSiteMap from '../../siteMap.json';
import dataTranslations from './translations.json';

//assets
import './popup.css';

class PopupUserTypeConfirmation extends Component {
	constructor() {
		super();

		this.state = {
			userType: false,
			userTypeShow: true,
		};

		this.openUserTypePopup = this.openUserTypePopup.bind(this);	
		this.closeUserTypePopup = this.closeUserTypePopup.bind(this);
		this.getCookie = this.getCookie.bind(this);
		this.setUserTypePreferenceCookie = this.setUserTypePreferenceCookie.bind(this);
	}

	openUserTypePopup() {
		this.setState({
			userTypeShow: true,
		});
	}

	closeUserTypePopup(event, preventDefault) {
		if (preventDefault) {
			event.preventDefault();
		}
		
		this.setUserTypePreferenceCookie();

		this.setState({
			userTypeShow: false,
		});
	}

	getCookie(cookieName) {
		cookieName += "=";

		const decodedCookie = decodeURIComponent(document.cookie);
		const cookieArray = decodedCookie.split(';');

		for (const cookie of cookieArray) {
			let currentCookie = cookie;

			while (currentCookie.charAt(0) === ' ') {
				currentCookie = currentCookie.substring(1);
			}
			if (currentCookie.indexOf(cookieName) === 0) {
				return currentCookie.substring(cookieName.length, currentCookie.length);
			}
		}

		return '';
	}

	setUserTypePreferenceCookie() {
		const today = new Date();
		let expire = new Date();

		expire.setTime(today.getTime() + 3600000 * 24 * 14);
		document.cookie = 'userTypePreference=true;expires=' + expire.toGMTString() + ';path=/';
	}

	render() {
		const cookieUserType = this.getCookie('userTypePreference');
		const culture = this.props.culture;
		let page = this.props.page;

		// we only want to show userType popup for UK and when on a sub page
		// and when no userTypePreference cookie is present
		if (!cookieUserType && this.state.userTypeShow && culture === 'uk' && page) {
			return (
				<div className="popup popup--usertype">
					<div className="popup__inner">
						<h2 className="popupusertype__title"><Translation culture={this.props.culture} data={dataTranslations.userTypeConfirmation} name="title" /></h2>
						<Link className="landing-page__button hwa" hrefLang={dataSiteMap[this.props.culture].cultureCode} onClick={(event) => this.closeUserTypePopup(event, false)} to={'/' + this.props.culture + '/hcp/' + dataSiteMap[this.props.culture].navigation['hcp'].pages.filter(({live}) => live === true)[0].key}>
							<h2 className="landing-page__button__title"><Translation culture={this.props.culture} data={dataTranslations.userTypeConfirmation} name="hcpTitle" /></h2>
							<p className="landing-page__button__body"><Translation culture={this.props.culture} data={dataTranslations.userTypeConfirmation} name="hcpBody" /></p>
						</Link>
						<Link className="landing-page__button landing-page__button--public hwa" hrefLang={dataSiteMap[this.props.culture].cultureCode} onClick={(event) => this.closeUserTypePopup(event, false)} to={'/' + this.props.culture + '/public/' + dataSiteMap[this.props.culture].navigation['public'].pages.filter(({live}) => live === true)[0].key}>
							<h2 className="landing-page__button__title"><Translation culture={this.props.culture} data={dataTranslations.userTypeConfirmation} name="publicTitle" /></h2>
							<p className="landing-page__button__body"><Translation culture={this.props.culture} data={dataTranslations.userTypeConfirmation} name="publicBody" /></p>
						</Link>
						<button className="popup__button popup__button--close hwa" onClick={(event) => this.closeUserTypePopup(event, true)}><Translation culture={this.props.culture} data={dataTranslations.userTypeConfirmation} name="close" /></button>
					</div>
				</div>
			);
		}
		
		return null;
	}
}

export default PopupUserTypeConfirmation;



// WEBPACK FOOTER //
// ./src/components/popup/userTypeConfirmation.js